import { render, staticRenderFns } from "./EmpresasRegistro.vue?vue&type=template&id=296c7931"
import script from "./EmpresasRegistro.vue?vue&type=script&lang=js"
export * from "./EmpresasRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports